var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-outframe view"},[_c('header-com',{attrs:{"tit":_vm.titText}}),_c('div',{staticClass:"container"},[_c('router-view')],1),_c('log'),_c('footer-com',{staticStyle:{"visibility":"hidden"}}),_c('footer-com',{staticStyle:{"bottom":"0px","position":"absolute","width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }